var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('crud',{ref:"crud",attrs:{"config":_vm.config},on:{"handle":_vm.handle}}),_c('feedBack-modal',{ref:"modalForm",on:{"ok":_vm.modalFormOk}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }